import Chip from '@mui/material/Chip';
import { chooseColor } from '../../utils/colors';
import { useTranslation } from 'react-i18next';

const colorMap = new Map([
    [true, '#EE8434'],
]);

const locationColor = (name) => {
    return colorMap.get(name)
};

function LocationChip({ isDefaultLocation }) {
    const { t } = useTranslation();
    const color = locationColor(isDefaultLocation)
    return <Chip label={isDefaultLocation ? t('hauptstandort', { ns: 'instituteConfigurationPage', defaultValue: 'Hauptstandort'}) : 'not defined'} sx={{ backgroundColor: color, color: chooseColor(color) }} />
}

export default LocationChip